<div class="modal-body" id="modal-body">
  <ng-container *ngIf="contentType === 'detail'; else listBlock">
    <app-currencies-detail [pk]="pk" [mode]="mode" [defaults]="defaults"
                                   (detailSaved)="modal.close($event)"
                                   (detailCancelled)="modal.dismiss()">
    </app-currencies-detail>
  </ng-container>
  <ng-template #listBlock>
    <app-currencies-list (rowClick)="modal.close($event)" [disableUrlUpdate]="true"
                                  [disabledButtons]="localDisabledButtons" [disabledColumns]="disabledColumns"
                                  [filters]="filters" [disableRouterLink]="true">
    </app-currencies-list>
  </ng-template>
</div>